import React from "react";

import styles from "./styles.module.scss";

const HeaderTableAction = ({ children, ...props }) => (
  <button className={styles.headerAction} {...props}>
    {children}
  </button>
);

export default HeaderTableAction;
